import { render } from "./SavedDocumentationsFiles.vue?vue&type=template&id=f50a056e"
import script from "./SavedDocumentationsFiles.vue?vue&type=script&lang=js"
export * from "./SavedDocumentationsFiles.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__